<template>
  <div>
    <el-dialog :modal="false" :visible.sync="showShare" :title="null" :width="isMobile()?'98%':'480'" custom-class="share-c" :show-close="false">
      <div class="sharePc">
        <div class="sharePc1" id="target">
          <div class="title-c">
            <img src="../assets/css/icon/left_icon.png" class="shareLogo"/>
            <div class="title">{{$t("copy_trading2")}}</div>
          </div>
          <div class="close" @click="showShare=false;">
            <img src="../assets/imgs/delete.svg" :style="isMobile()?{width:'14px',height:'14px'}:{}"/>
          </div>

          <div class="content">
            <img class="img" src="../assets/css/icon/head.svg"/>
            <div class="name">{{name}}</div>
          </div>
          <div class="moneyC">
            <div class="item" :style="{visibility:this.profitRate?'visible':'hidden'}">
              <div class="title">{{$t('aum')}}</div>
              <div class="value">{{total.toFixed(2)}}</div>
            </div>
            <div class="item" v-if="this.winRate">
              <div class="title">{{$t('unrealized_pnl')}}</div>
              <div class="value">{{unpnl.toFixed(2)}}</div>
            </div>
          </div>
          <div class="moneyC">
            <div class="item" v-if="this.showProfit" >
              <div class="title">{{$t('project_total_profit_loss')}}</div>
              <div class="value">{{totalProfit.toFixed(2)}}</div>
            </div>
            <div class="item" :style="{visibility:this.showAddress?'visible':'hidden'}">
              <div class="title">{{$t('currency')}}</div>
              <div class="value">{{symbol}}</div>
            </div>
          </div>
          <div class="open">
            <span class="title"></span>
            <span class="value"></span>
          </div>
          <div class="open">
            <span class="title"></span>
            <span class="value"></span>
          </div>
          <div class="qrC">
            <div class="qrCode">
              <vue-qr class="qrCode" :text="showUrl" :logSrc="require('../assets/imgs/fufuture-1.svg')"
                      :logo-scale="20"/>
            </div>
            <div class="qrTitle">{{$t("referral_code")}}</div>
            <div class="qrMiddle"></div>
            <div class="qrTitle2">{{$t('time')}}: {{now}}</div>
          </div>
        </div>
        <div class="shareNotice">
          <div class="title">{{$t('select_metric')}}</div>
          <div class="radio-c">
            <el-checkbox class="item" v-model="profitRate">{{$t('aum')}}</el-checkbox>
            <el-checkbox class="item" v-model="winRate">{{$t('unrealized_pnl')}}</el-checkbox>
            <el-checkbox class="item" v-model="showProfit">{{$t('project_total_profit_loss')}}</el-checkbox>
            <el-checkbox class="item" v-model="showAddress">{{$t('trading_currency')}}</el-checkbox>
          </div>
        </div>
        <div class="actions">
          <div class="cancel" @click="copy">{{$t('copy_link')}}</div>
          <div class="download" @click="download">{{$t('download')}}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import vueQr from 'vue-qr'
import html2canvas from "html2canvas";
import {getHistoryData, getTransData} from "../service/queryService";
import {getAccount} from "../utils/wallet";
import {createLeadingContractAndCall, getSelectTokenInfo} from "../utils/contract";
import {Method, Underling} from "../config/const";
import {BigNumber} from "ethers";
import {isMobile, transBig2number, transNumber2Big, transTime2Date} from "../utils/functions";
import {getLastPrice} from "../service/priceService";
import {getCacheOnCallBack} from "../service/cacheService";

export default {
  components: {
    vueQr
  },
  props:{
    contract:"",
    token:"",
  },

  data() {
    return {
      showShare: false,
      showUrl: "",
      time:"7",
      profitRate:true,
      winRate:true,
      showProfit:true,
      showAddress:true,
      profitRateNumber:"+0",
      winRateNumber:"+0",
      now:"",
      name:"",
      total:0,
      unpnl:0,
      totalProfit:0,
      symbol:""
    }
  },
  methods: {
    isMobile,
    async show(userName,total,unpnl,totalProfit) {
      this.showUrl="https://cf.fufuture.io/#/listPage?contract="+this.contract+"&token="+this.token;
      this.showShare = true;
      this.now=transTime2Date()
      this.name=userName;
      if(total!=0){
        this.total=Number(total);
      }else{
        getCacheOnCallBack(this.token+"_total",(v)=>{
          console.log("total is back",v);
          this.total=Number(v);
        })
      }
      if(unpnl!=0){
        this.unpnl=Number(unpnl)
      }else{
        getCacheOnCallBack(this.token+"_unpnl",v=>this.unpnl=Number(v))
      }
      if(totalProfit!=0){
        this.totalProfit=Number(totalProfit)
      }else{
        getCacheOnCallBack(this.token+"_allProfit",v=>this.totalProfit=Number(v))
      }

      let tokenInfo=await getSelectTokenInfo(this.token);
      this.symbol=tokenInfo.symbol;

      console.log("share will show");
      // this.getData();
    },
    update(total,unpnl,totalProfit){
      this.total=Number(total);
      this.unpnl=Number(unpnl);
      this.totalProfit=Number(totalProfit);
    },
    hide() {
      this.showShare = false;
    },
    async download(){
      const div = document.getElementById('target');
      const canvas = await html2canvas(div);
      const url = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = url;
      a.download = 'share.png';
      a.click();
      this.$message.success(this.$t('download_success'))
    },
    async copy(){
      await navigator.clipboard.writeText(this.showUrl);
      await this.$message.success(this.$t('copy_success'))
    },
    async getData(){

      let start=parseInt(new Date().getTime()/1000)-(86400*this.time);
      let orderHistories=await getHistoryData(this.contract,0,start,0);
      let total=0;
      let win=0;
      for(let i in orderHistories.orderHistories){
        let item=orderHistories.orderHistories[i];
        if(item.orderType!=3 && item.orderType !=4){
          continue;
        }
        total++;
        if(item.direction==1 && (BigNumber.from(item.costPrice).lte(BigNumber.from(item.price)))){
          win++;
        }else if(item.direction==2 && (BigNumber.from(item.costPrice).gte(BigNumber.from(item.price)))){
          win++;
        }
      }
      if(total>0){
        this.winRateNumber="+"+(win*100/total).toFixed(2)
      }
      console.log("win rate is",total,win,this.winRateNumber);

      let lastDay=await createLeadingContractAndCall(this.contract,Method.getAssetSharesHistoryDays);
      let profitDay=lastDay-this.time;
      if(profitDay<=0){
        profitDay=0;
      }
      let data=await createLeadingContractAndCall(this.contract,Method.getSupplyBalanceHistoryAtMultiple,[profitDay])
      let profitDayShare=0;
      console.log("asset data is",data);
      if(data && data.length>0 && data[0].totalAsset.gt(BigNumber.from(0))){
        profitDayShare=parseFloat(data[0].totalAsset.mul(BigNumber.from(100000000)).div(data[0].totalAsset).toString())/100000000;
      }

      let price = await getLastPrice()
      let priceBTC = transBig2number(price[Underling.BTC].price, price[Underling.BTC].decimal, 6);
      let priceETH = transBig2number(price[Underling.ETH].price, price[Underling.ETH].decimal, 6);

      let priceBtcNum = transNumber2Big(priceBTC);
      let priceEthNum = transNumber2Big(priceETH);

      let asset2 = await createLeadingContractAndCall(this.contract, Method.getTotalBalance, [Underling.BTC, Underling.ETH], [priceBtcNum, priceEthNum]);
      console.log("asset2 is", asset2);
      asset2 = asset2.assetAmount ?? "0";


      let totalShare = await createLeadingContractAndCall(this.contract, Method.totalShare);
      totalShare = totalShare ?? 0;
      console.log("total share is",totalShare);

      if(totalShare.gt(BigNumber.from(0))){
        let shareValue = asset2.mul(BigNumber.from(100000000)).div(totalShare)
        console.log("share value and asset is", shareValue, asset2);

        let priceRate = (parseFloat(shareValue.toString()) / 100000000);

        let rate=((priceRate-profitDayShare)*100);
        this.profitRateNumber=(rate>0?"+":"")+rate.toFixed(2);
        console.log("profit and win is",this.profitRateNumber,this.winRateNumber,profitDayShare,priceRate);
      }
    }
  },
  watch:{
    time(){
      this.getData()
    }
  }
}
</script>
<style lang="less" scoped>

  ::v-deep .share-c{
    width: 420px;
    background: transparent !important;
    box-shadow:revert !important;
  }





.title-c {
  display: flex;
  align-items: center;

  .title {
    margin-left: 20px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 20.27px;
    color: rgba(255, 255, 255, 1);
  }
}

.sharePc {
  width: 480px;
  height: 480px;
  border-radius: 16px;
  background-image: url('../assets/imgs/pc.svg');
  background-size: cover;
  background-position: center; // 居中显示
  background-repeat: no-repeat; // 不重复
  position: relative;
  .close{
    position: absolute;
    top: 24px;
    right: 24px;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }

  &.mobile {
    border-radius: 12px;
    width: 320px;
    height: 568px;
  }

  .sharePc1 {
    background-image: url('../assets/imgs/pc_top.svg');

    &.mobile {
      background-image: url('../assets/imgs/mobile_top.svg');
    }

    background-size: cover;
    background-position: center; // 居中显示
    background-repeat: no-repeat; // 不重复
    border-radius: 16px;
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 18px;

    .shareLogo {
      width: 100px;
      height: 27px;
      object-fit: contain;
    }

    .content {
      display: flex;
      gap: 8px;
      margin-top: 22px;
      align-items: center;
      font-weight: 500;

      .img{
        width: 23px;
      }
      .name{
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 1px;
        line-height: 16.93px;
        color: rgba(234, 236, 239, 1);
      }

      &.mobile {
        margin-top: 44px;
      }

      .direct {
        font-size: 14px;
        color: #C6FE61FF;
      }

      .label {
        font-size: 14px;
        color: #E5E5E5FF;

      }
    }

    .moneyC {
      margin-top: 16px;
      margin-bottom: 5px;
      font-family: gilroy;
      display: flex;
      gap: 48px;
      .item{
        width: 150px;
      }
      .title{
        font-size: 11px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 15.93px;
        color: rgba(229, 229, 229, 1);
      }
      .value{
        font-size: 24px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 29.02px;
        color: rgba(198, 254, 97, 1);
        margin-top: 4px;
      }
    }

    .open {

      .title {
        font-size: 11px;
        color: #E5E5E5FF;
      }

      .value {
        font-size: 11px;
        color: #C6FE61FF;
      }
    }

    .qrC {
      margin-top: 32px;
      display: grid;
      grid-template-columns: auto auto 1fr auto;
      align-items: end;

      &.mobile {
        grid-template-rows: auto auto;
        grid-template-columns: repeat(2, 1fr); // 三列
      }

      &.mobile {
        margin-top: 66px;
      }

      .qrCode {

        width: 46px;
        height: 46px;
        background: #FFFFFF;
        border-radius: 4px;
        padding: 1px;
        position: relative;

        &.mobile {
          grid-column: 1 / 4;
        }

        .qrCodeSvg {
          width: 44px;
          height: 44px;
        }

        .qrCodeLogo {
          width: 15px;
          height: 15px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          border-radius: 50%;
          background: #FFFFFF;
          padding: 2px;
          box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
        }
      }

      .qrTitle {
        font-size: 10px;
        color: #A6A6A6FF;
        margin-left: 10px;

        &.mobile {
          //  grid-column: 1;
          grid-row: 2;
          margin-left: 0px;
          margin-top: 10px;

        }

      }

      .qrTitle2 {
        font-size: 10px;
        color: #A6A6A6FF;
        margin-left: 10px;

        &.mobile {
          //  grid-column: 1;
          grid-row: 2;
          margin-left: 0px;
          margin-top: 10px;
          text-align: right;
        }

      }

      .qrMiddle {
        &.mobile {
          display: none;

        }
      }
    }
  }

  .shareNotice {
    margin-top: 16px;
    font-size: 12px;
    color: #A6A6A6FF;
    margin-left: 24px;
    .title{
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 17.38px;
      color: rgba(166, 166, 166, 1);
    }
    .radio-c{
      display: flex;
      margin-top: 16px;
      flex-wrap: wrap;
      .item{
        width: 90px;
      }

      .el-input__suffix-inner {
        .el-select__caret {
          font-family: 'element-icons' !important; // 确保使用 Element UI 的字体

          &.el-icon-arrow-up::before {
            content: "\e78f"; // 替换为你想用的 Element UI 图标的 Unicode 编码
          }

          &.el-icon-arrow-down::before {
            content: "\e790"; // 和展开时使用同一个图标的 Unicode
          }
        }
      }
      ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
        color: rgba(255, 255, 255, 1) !important;
      }
      ::v-deep .el-radio__input.is-checked+.el-radio__label{
        color:white !important;
      }
      ::v-deep .el-radio__input.is-checked .el-radio__inner {
        background: url('../assets/imgs/radio.svg') no-repeat center;
        border: none;
      }
      ::v-deep .el-radio__inner::after{
        background: transparent;
      }
    }
  }

  .shareButtons {
    margin-top: 13px;
    display: flex;
    margin-left: 24px;
    align-items: center;

    .shareBtnText {
      color: #fff;
      font-weight: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;
    }
  }

  .actions {
    display: flex;
    margin-left: 24px;
    margin-right: 24px;
    margin-top: 18px;
    gap: 12px;
    margin-bottom: 20px;

    .cancel {
      height: 34px;
      text-align: center;
      line-height: 34px;
      color: #fff;
      font-size: 13px;
      font-weight: 700;
      flex: 1;
      border-radius: 6px;
      background: #525252FF;
      cursor: pointer;
    }

    .download {
      cursor: pointer;
      height: 34px;
      flex: 1;
      text-align: center;
      line-height: 34px;
      color: #333333FF;
      font-size: 13px;
      font-weight: 700;
      border-radius: 6px;
      background: #C6FE61FF;
    }
  }
}
  @media (max-width: 750px) {
    .sharePc {
      width: 100%;
      .moneyC{
        gap: 12px !important;
      }
    }

  }
</style>
